export default __webpack_public_path__ + "static/20240530-7484ecbc4d77030dc7dda3aa50fb0dfa.png";